import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3B3A3A',
        secondary: '#4caf50',
        tertiary: '#ECEAE9',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#5cb860',
        warning: '#ffa21a',
        gray: '#252525',
        neutral: '#ffffff',
      },
    },
  },
});
